import { Flex, Skeleton } from "antd";
import { useMemo } from "react";

import {
    StyledAPContainer,
    StyledAPImageWrapper,
    StyledAPTable,
    StyledAPTableRow,
} from "./Styled";

export const AboutPointPageSkeleton = () => {
    const widths = useMemo(
        () =>
            Array.from({ length: 6 }, () => ({
                left: 80 + Math.floor(Math.random() * 100),
                right: 60 + Math.floor(Math.random() * 120),
            })),
        [],
    );

    return (
        <StyledAPContainer>
            <Flex align="center" gap={12}>
                <StyledAPImageWrapper>
                    <Skeleton.Image style={{ width: 60, height: 60 }} />
                </StyledAPImageWrapper>

                <Flex vertical gap={8}>
                    <Skeleton.Input style={{ height: 20 }} />

                    <Skeleton.Input style={{ height: 20, width: 240 }} />
                </Flex>
            </Flex>

            <Skeleton.Button
                style={{
                    height: 45,
                    width: 220,
                    display: "block",
                    margin: "0 auto",
                }}
            />

            <StyledAPTable>
                {widths.map((w, index) => (
                    <StyledAPTableRow key={index}>
                        <Skeleton.Input
                            style={{ height: 20, width: w.left, minWidth: 80 }}
                        />
                        <Skeleton.Input
                            style={{
                                height: 20,
                                width: w.right,
                                minWidth: 80,
                                marginLeft: "auto",
                                display: "block",
                            }}
                        />
                    </StyledAPTableRow>
                ))}
            </StyledAPTable>
        </StyledAPContainer>
    );
};
